import React from 'react';
import gpt3Logo from '../../logo.svg';
import './footer.css';

const Footer = () => (
  <div className="gpt3__footer section__padding">



    <div className="gpt3__footer-links">
      
      <div className="gpt3__footer-links_div">
        <h4>Links</h4>
        <p> <a href='https://drive.google.com/file/d/11ZY5aPSvBnLp0ru3X3rooTzKt0gu7_p4/view' target='_blank'>info</a></p>
        <p> <a href='www.hiphopcryptowatch.com' target='_blank'> blog</a></p>
      </div>
      <div className="gpt3__footer-links_div">
        <h4>Company</h4>
        <p> <a href='https://drive.google.com/file/d/11ZY5aPSvBnLp0ru3X3rooTzKt0gu7_p4/view' target='_blank'>copyright information</a></p>
        <p><a href='https://drive.google.com/file/d/11ZY5aPSvBnLp0ru3X3rooTzKt0gu7_p4/view' target='_blank'>Privacy Policy</a></p>
        <p><a href='https://drive.google.com/file/d/11ZY5aPSvBnLp0ru3X3rooTzKt0gu7_p4/view' target='_blank'>patent information</a> </p>
      </div>
      <div className="gpt3__footer-links_div">
        <h4>Get in touch</h4>
        <p>gabrielc247@gmail.com</p>
      </div>
    </div>
    <div className="gpt3__footer-copyright">
    </div>
  </div>
);

export default Footer;
{/* <a href='www.hiphopcryptowatch.com' target='#blank'> */}